<div>
    <ng-select bindLabel="name" class="language-selector" (change)="onChange($event)" [clearable]="false"
        [items]="languages" [searchable]="false" [(ngModel)]="selectedLanguage">
        <ng-template ng-option-tmp let-item="item">
            <div class="language-item-container">
                <div class="language-item-code">{{ item.countryCode }}</div>
                <div>{{ item.name }}</div>
            </div>
        </ng-template>
    </ng-select>
</div>